import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
//////////////////////////////////////////////////

const store = R.path(['claimManagement', 'claimDetails']);

const makeSelectGeneralDetails = () => createSelector(
  store,
  R.prop('generalDetails'),
);

const makeSelectDropdownOptionsByDropdownNames = createSelector(
  [
    R.path(['claimManagement', 'claimDetails', 'configGroup', 'dropdownOptions']),
    (_, dropdownNames) => dropdownNames,
  ],
  (dropdownOptions, dropdownNames = []) => {
    if (G.isNilOrEmpty(dropdownNames)) return dropdownOptions;

    const dropdownOptionsByNames = R.pickAll(R.split(',', dropdownNames), R.or(dropdownOptions, {}));

    return dropdownOptionsByNames;
  },
);

const makeSelectClaimGuid = () => createSelector(
  store,
  R.path(['generalDetails', GC.FIELD_GUID]),
);

const makeSelectClaimGuidAndClaimBranchGuid = () => createSelector(
  [
    R.path(['claimManagement', 'claimDetails', 'generalDetails', GC.FIELD_GUID]),
    R.path(['claimManagement', 'claimDetails', 'generalDetails', GC.BRANCH_GUID]),
  ],
  (claimGuid, claimBranchGuid) => ({ claimGuid, claimBranchGuid }),
);

const makeSelectHeaderInfo = () => createSelector(
  R.path(['claimManagement', 'claimDetails', 'generalDetails']),
  ({ type, status, reason, subStatus, claimDate, paidAmount, claimNumber }) => ({
    claimDate,
    paidAmount,
    claimNumber,
    claimType: G.getDisplayedValueFromObject(type),
    claimReason: G.getDisplayedValueFromObject(reason),
    claimStatus: G.getDisplayedValueFromObject(status),
    claimSubStatus: G.getDisplayedValueFromObject(subStatus),
  }),
);

const makeSelectClo = () => createSelector(
  R.path(['claimManagement', 'claimDetails', 'generalDetails', GC.FIELD_CLO]),
  R.clone,
);

const makeSelectTel = () => createSelector(
  R.path(['claimManagement', 'claimDetails', 'generalDetails', GC.FIELD_TEL]),
  R.clone,
);

const makeSelectDocuments = () => createSelector(
  store,
  R.prop('documents'),
);

const makeSelectNotes = () => createSelector(
  store,
  R.prop('notes'),
);

const makeSelectPinnedNote = () => createSelector(
  R.pathOr([], ['claimManagement', 'claimDetails', 'notes']),
  R.find(R.propEq(true, 'pinned')),
);

const makeSelectRelatedTels = () => createSelector(
  store,
  R.prop('relatedTels'),
);

const makeSelectCloItems = () => createSelector(
  store,
  R.prop('cloItems'),
);

const makeSelectDamagedItemsByCloItemGuid = createSelector(
  [
    R.path(['claimManagement', 'claimDetails', 'groupedByCloItemGuidDamagedItems']),
    (_, cloItemGuid) => cloItemGuid,
  ],
  (grouped, guid) => R.prop(guid, grouped),
);

const makeSelectAccident = () => createSelector(
  store,
  R.prop('accident'),
);

const makeSelectInvolvedPartyList = () => createSelector(
  store,
  R.prop('involvedPartyList'),
);

const makeSelectAttorneyList = () => createSelector(
  store,
  R.prop('attorneyList'),
);

const makeSelectBillTo = () => createSelector(
  store,
  R.prop('billTo'),
);

export {
  makeSelectClo,
  makeSelectTel,
  makeSelectNotes,
  makeSelectBillTo,
  makeSelectAccident,
  makeSelectCloItems,
  makeSelectDocuments,
  makeSelectClaimGuid,
  makeSelectPinnedNote,
  makeSelectHeaderInfo,
  makeSelectRelatedTels,
  makeSelectAttorneyList,
  makeSelectGeneralDetails,
  makeSelectInvolvedPartyList,
  makeSelectDamagedItemsByCloItemGuid,
  makeSelectClaimGuidAndClaimBranchGuid,
  makeSelectDropdownOptionsByDropdownNames,
};
